import { useProductInfo } from "@expert/contentful";
import { isProd } from "@/call-controls/constants";
import { usePartner } from "@/sdk";
import { userCache } from "@/shared-utils";

export const useIsSalesEnabled = (): boolean => {
    const partner = usePartner();
    const { productInfo } = useProductInfo(partner, userCache.employeeId);

    const allProductsAdGroups =
        Object.values(productInfo ?? {}).flatMap((p) => {
            const group = p.adGroup;
            if (group == null) return [];
            return group;
        }) ?? [];

    const userHasAdGroup = isProd
        ? allProductsAdGroups.length === 0
            ? true
            : allProductsAdGroups.some((adGroup) => userCache.containsGroup(adGroup))
        : true;

    return !!productInfo && Object.entries(productInfo).length > 0 && userHasAdGroup;
};
